import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { AttributeGroupAccordion } from "./AttributeGroupAccordion";
import { AttributeGroupContent } from "./AttributeGroupContent";
import { AttributeGroupVariant, } from "./AttributeGroupProps";
import { AttributeGroupSimple } from "./AttributeGroupSimple";
export function AttributeGroup(props) {
    const { variant = AttributeGroupVariant.Accordion } = props;
    switch (variant) {
        case AttributeGroupVariant.Accordion:
            return _jsx(AttributeGroupAccordion, Object.assign({}, props));
        case AttributeGroupVariant.Simple:
            return _jsx(AttributeGroupSimple, Object.assign({}, props));
        case AttributeGroupVariant.Content:
            return _jsx(AttributeGroupContent, Object.assign({}, props));
        default:
            return _jsx(Fragment, {});
    }
}
//# sourceMappingURL=AttributeGroup.js.map